export enum PatientDataAccessLogReason {
    PractitionerIsInvolvedWithPatient = 'practitionerIsInvolvedWithPatient',
}
